/* eslint-disable */
import Api from '@/api/services/Api';

const route = '/role'

export default {
    get: params => Api().get(`${route}`, { params, crossDomain: true }),
    // post: payload => Api().post(`${route}`, payload),
    // put: payload => Api().put(`${route}/${payload.id}`, payload),
    // delete: payload => Api().delete(`${route}/${payload.id}`),
    // enable: payload => Api().put(`${route}/enable/${payload.id}`)
}
